export const AuthPractiquesEmpresa = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Carta de compromís de pràctiques en empresa (dual general i intensiva)
        </h4>
        <p>

          <h5>Declaració de l'alumne:</h5>

          <ul>
            <li>En el cas que renunciï a l’empresa que m’ofereix el centre, m’hauré de buscar jo l’empresa per fer les pràctiques.</li>
            <li>En el cas que abandoni, una vegada ja començada la formació pràctica, seré jo mateix qui em buscaré l’empresa per fer les pràctiques.</li>
            <li>Que si sóc alumne/a Erasmus, i dual intensiva; em comprometo a realitzar 713 hores (mínim) a l’empresa on faig dual intensiva.</li>
            <li>Em comprometo a complir l’horari, tant en l’empresa com en l’institut (i no perdre la convocatòria ordinària), en cas contrari, des del centre es finalitzarà anticipadament l’acord, i hauré de realitzar les pràctiques el següent curs.</li>
            <li>Que si treballo cada matí, hauré de posposar les pràctiques a un tercer curs (en el cas que no pugui demanar exempció total).</li>
            <li>Què si per la meva situació personal demano semipresencialitat al centre, hauré de posposar les pràctiques a un tercer curs.</li>
            <li>Em comprometo durant el primer trimestre a obtenir el NASS (núm. d’afiliació de la Seguretat Social), i si sóc major d’edat a tenir SIGNATURA DIGITAL.</li>
            <li>He d’emplenar cada dia les activitats a la plataforma SBID, i al finalitzar cada mes, fer la valoració corresponent. Al finalitzar les pràctiques, emplenar el qüestionari final.</li>
            <li>En el cas d’absentar-me de l’empresa, o tenir qualsevol problema, hauré d’informar a l’empresa i al centre (al tutor/a SBID).</li>
            <li>Emplenaré el formulari de dades per poder començar les pràctiques, que se m’enviarà durant el mes de gener, dins del termini marcat.</li>
            <li>En fer la matrícula, m’han informat dels trets específics d’aquest cicle formatiu i dels requisits addicionals que haig de tenir en compte com a alumne/a que s’hi matricula.</li>
            <li>L’incompliment d’algun dels punts anteriors, comportarà la sanció especificada en la guia de pràctiques i en la Normativa de centre (NOFC).</li>
          </ul>

          <br />

          <label>
            <input type="checkbox" id="authPractiquesEmpresa" name="authPractiquesEmpresa" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
            Accepto i em comprometo a seguir els acords establerts anteriorment, assumint totes les responsabilitats que se’n deriven.
          </label>

          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>

        </p>


      </div>
    </div>

    <br />

  </>)
}
